"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var media_1 = require("../../styles/media");
var container_type_1 = require("./container-type");
exports.StyledContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #fff;\n  padding: 32px;\n  border-radius: ", ";\n  width: ", ";\n  margin-inline: ", ";\n\n  ", "\n"], ["\n  background-color: #fff;\n  padding: 32px;\n  border-radius: ", ";\n  width: ", ";\n  margin-inline: ", ";\n\n  ", "\n"])), function (props) { return (props.type === container_type_1.ContainerType.FULL_WIDTH ? '0' : '4px'); }, function (props) { return props.width; }, function (props) {
    var type = props.type;
    if (type === container_type_1.ContainerType.FULL_WIDTH) {
        return '0';
    }
    else if (type === container_type_1.ContainerType.MARGIN_AUTO) {
        return 'auto';
    }
    return '32px';
}, (0, media_1.mediaStyle)()(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-inline: ", ";\n  "], ["\n    margin-inline: ", ";\n  "])), function (props) {
    var type = props.type;
    if (type === container_type_1.ContainerType.FULL_WIDTH) {
        return '0';
    }
    else if (type === container_type_1.ContainerType.MARGIN_AUTO) {
        return 'auto';
    }
    return '16px';
}));
var templateObject_1, templateObject_2;
